//import { useState, useEffect, useCallback, Fragment } from 'react';
import { FunctionComponent } from 'react';
import './persona.scss';

export type Props = {
  area: string;
  slogan: string;
  description: () => JSX.Element;
  showcaseurl: string;
};

const Persona: FunctionComponent<Props> = (props) => {
  //const history = useNavigate();

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <div className="persona-preview">
      <h3>{props.area}</h3>
      <h4>{props.slogan}</h4>
      <p>
        {props.description()}
        <br /> <a href={props.showcaseurl}>Zum Showcase</a>
      </p>
    </div>
  );
};

export default Persona;
